import IndexPage from "../../Crud/IndexPage"
const Settings = () => {

    const mainPath = "/help/settings"
    return (
        <IndexPage
            title="Hilfe Einstellungen"
            items={[
                { text: "Kategorien Einstellungen", path: `${mainPath}/categories` },
                { text: "Produkte Einstellungen", path: `${mainPath}/products` },
                { text: "Extras Einstellungen", path: `${mainPath}/extras` },
                { text: "Rabatte Einstellungen", path: `${mainPath}/offers` },
                { text: "Coupons Einstellungen", path: `${mainPath}/coupons` },
                { text: "Mitarbeiter Einstellungen", path: `${mainPath}/workers` },
                { text: "Workspace Einstellungen", path: `${mainPath}/workspace` },
            ]}
        />
    )
}
export default Settings